export default "__VITE_ASSET__BMSajDXd__"